import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

export const EVENTS = {
  homeViewed: "Home - viewed",
  bookmarkedItemClicked: "Bookmarks - clicked",
  googleLinkClicked: "Mobile - google_link_clicked",
  iOSLinkClicked: "Mobile - iOS_link_clicked",
  howToLinkClicked: "Mobile - how_to_link_clicked",
  mobileViewed: "Mobile - viewed",
  eCommerceProductListViewed: "Ecommerce - product_list_viewed",
  eCommerceProductSelected: "Ecommerce - product_selected",
  eCommercePaymentSuccess: "Ecommerce - payment_success",
};

export const logHomeViewed = () => {
  amplitude.log(EVENTS.homeViewed, {});
};

export const logBookmarkedItemClicked = ({ title, record_an }) => {
  amplitude.log(EVENTS.bookmarkedItemClicked, {
    title,
    record_an,
  });
};

export const logGoogleLinkClicked = (affordance) => {
  amplitude.log(EVENTS.googleLinkClicked, { affordance });
};
export const logIOSLinkClicked = (affordance) => {
  amplitude.log(EVENTS.iOSLinkClicked, { affordance });
};
export const logHowToLinkClicked = (affordance) => {
  amplitude.log(EVENTS.howToLinkClicked, { affordance });
};

export const logMobileViewed = () => {
  amplitude.log(EVENTS.mobileViewed, {});
};

export const logSubscriptionNavigation = (type, details) => {
  amplitude.log(type, details);
};
